import { AxiosResponse } from 'axios'
import api from '~/services/api' // TODO: Пофиксить для FSD
import {
  IGetRestNameResult,
  IGetRestNameResponse,
  IRestWork,
  IGetShopNameResponse,
  IGetIdByCodeResponse
} from '../model/types'

export const getRestaurantCode = async (platform: string, id: string, timeout?: number): Promise<IGetRestNameResult> => {
  const res: AxiosResponse<IGetRestNameResponse> = await api.get(
      `/restaurant/determine-code?platform=${platform}&restaurant=${id}`,
      { timeout }
  )
  return Array.isArray(res.data.result) ? res.data.result[0] : res.data.result
}

export const getRestaurantTitle = async (code: string, timeout?: number) => {
  const { data }: AxiosResponse<IGetShopNameResponse> = await api.get(`shop/name-by-code/${code}`, { timeout })
  return data.result
}

export const getStatusWork = async (requestData: string, tableId: string, timeout?: number): Promise<IRestWork> => {
  const { data }: AxiosResponse<IRestWork> = await api.get(`shop/availability/${requestData}?table_id=${tableId}`, { timeout })
  if (!data.result) {
    return {
      ...data,
      stub_types: ['FULL']
    }
  }
  return data
}

export const getIdByCode = async (code: string, timeout?: number): Promise<number> => {
  const { data }: AxiosResponse<IGetIdByCodeResponse> = await api.get(`shop/${code}/id`, { timeout })
  return data.result
}
